// src/pages/expense/env/disinfection/ExpenseEnvDisinfectionDraftNew.jsx
// ✅ 전 사업 확산 [2] — 환경/소독 "지출데이터+기안 작성" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftNew.jsx(공통 컴포넌트)에 있고, 이 파일은
// 환경/소독 전용 config(envDisinfectionConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftNew from "../../_shared/ExpenseDraftNew";
import envDisinfectionConfig from "./envDisinfectionConfig";

export default function ExpenseEnvDisinfectionDraftNew() {
  return <ExpenseDraftNew config={envDisinfectionConfig} />;
}
